import { SearchEntity } from '@finance-lab/utils/types'

export function getSearchEntityLabel(entity: SearchEntity): string {
    if (entity.entityType === 'Issue') {
        return entity.instrumentName ?? entity.name ?? ''
    }
    return entity.name ?? ''
}
